import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { useIntl } from 'react-intl';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';
import { Icon, NumericInput } from 'tacho-ui';

interface SetCarsLimitModalProps {
    isOpen: boolean;
    limit: number;
    onToggle: () => void;
    onSave: (limit: number) => void;
}

export const SetCarsLimitModal = (props: SetCarsLimitModalProps) => {
    const { formatMessage } = useIntl();
    const [limit, setLimit] = useState(props.limit);

    useEffect(() => {
        if (props.limit !== undefined) {
            setLimit(props.limit);
        }
    }, [props.limit]);

    return (
        <TachoModal
            size={'md'}
            height="auto"
            isOpen={props.isOpen}
            title={<TachoEditModalTitle icon={Icon.Restore} titleToTranslation="licenceAllowCarStatusCounterReset" />}
            cancelLabelToTranslate="tachoModalClose"
            onToggle={() => props.onToggle()}
            submitLabelToTranslate="commonUpdate"
            submitIcon={Icon.Save}
            onSubmit={() => {
                props.onSave(limit);
                props.onToggle();
            }}
        >
            <Container className="setCarsLimitContainer d-flex flex-column px-5 mt-2 gap-3">
                <Row>
                    <NumericInput
                        labelLength={5}
                        inputLength={1}
                        value={limit}
                        min={0}
                        label={formatMessage({ id: 'licencesAvailableCarStatusChanges' })}
                        onChange={setLimit}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
